import { AlertTriangle, GitBranch, MessageSquareText } from "lucide-react";

import { primeiraFalaDoFluxo } from "../../helpers/previaDoFluxo";

// A primeira coisa que o cliente recebe quando o fluxo começa, desenhada como
// balão de conversa. É o que confirma, antes de enviar, que o fluxo escolhido
// é o certo — o nome sozinho engana.
const PreviaDoFluxo = ({ fluxo, nome }) => {
	const previa = primeiraFalaDoFluxo(fluxo, nome);

	if (previa.tipo === "vazio") {
		return (
			<p className="flex gap-2 rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
				<AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
				Este fluxo não tem nenhum passo ligado ao início. Abra-o em Fluxos e
				ligue o gatilho ao primeiro passo antes de enviar.
			</p>
		);
	}

	if (previa.tipo === "outroNumero") {
		return (
			<p className="flex gap-2 rounded-lg bg-amber-50 p-3 text-sm text-amber-800 dark:bg-amber-500/10 dark:text-amber-300">
				<AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
				<span>
					O primeiro passo deste fluxo manda mensagem para um número fixo
					{previa.numero ? ` (${previa.numero})` : ""}, não para esta pessoa.
				</span>
			</p>
		);
	}

	if (previa.tipo === "ramifica") {
		return (
			<p className="flex gap-2 rounded-lg bg-muted p-3 text-sm text-muted-foreground">
				<GitBranch className="mt-0.5 h-4 w-4 shrink-0" />
				A primeira mensagem depende de uma condição do fluxo — muda de pessoa
				para pessoa.
			</p>
		);
	}

	if (previa.tipo === "silencioso") {
		return (
			<p className="flex gap-2 rounded-lg bg-muted p-3 text-sm text-muted-foreground">
				<MessageSquareText className="mt-0.5 h-4 w-4 shrink-0" />
				Este fluxo não manda mensagem: só faz ações na conversa (etiqueta,
				fila, atendente…).
			</p>
		);
	}

	return (
		<div className="space-y-2 rounded-lg bg-muted/60 p-3">
			<p className="text-xs font-medium text-muted-foreground">
				A primeira mensagem que chega para a pessoa
			</p>
			<div className="max-w-[90%] whitespace-pre-wrap break-words rounded-lg rounded-tl-none border bg-card px-3 py-2 text-sm leading-relaxed text-card-foreground shadow-xs">
				{previa.texto || "(sem texto)"}
				{previa.opcoes?.length > 0 && (
					<ul className="mt-2 space-y-1 border-t pt-2">
						{previa.opcoes.map((opcao, indice) => (
							<li key={indice} className="flex gap-2">
								<span className="font-semibold tabular-nums">
									{opcao.numero}
								</span>
								<span>{opcao.rotulo}</span>
							</li>
						))}
					</ul>
				)}
			</div>
			{previa.esperaResposta && (
				<p className="text-xs leading-relaxed text-muted-foreground">
					O fluxo espera a resposta. O que a pessoa responder continua o fluxo.
				</p>
			)}
		</div>
	);
};

export default PreviaDoFluxo;
